export const RECEIVE_DAY_CHANGES = 'RECEIVE_DAY_CHANGES';
export const RECEIVE_HAS_DAY_CHANGES = 'RECEIVE_HAS_DAY_CHANGES';
export const RECEIVE_PROVIDER_CHANGES = 'RECEIVE_PROVIDER_CHANGES';
export const RECEIVE_HAS_DAY_CHANGES_ALL = 'RECEIVE_HAS_DAY_CHANGES_ALL';
export const RECEIVE_DAY_CHANGES_ALL = 'RECEIVE_DAY_CHANGES_ALL';
// Modification en cours d'une catégorie supprimée : rechargement complet.
export const CATEGORY_CHANGES_CANCELLED = 'CATEGORY_CHANGES_CANCELLED';
// Composition d'un menu enregistrée (niveaux, produits) : décompte à recharger.
export const PRODUCT_MENU_CHANGES_SAVED = 'PRODUCT_MENU_CHANGES_SAVED';
